import React, { FunctionComponent, Suspense } from 'react';

import Header from './Header';
import SideBar from './SideBar';
import { Container } from '@material-ui/core';
import styles from './Layout.module.scss';
import Loader from '../Loader';
interface props {
  children?: JSX.Element;
}

const Layout: FunctionComponent<props> = ({ children }) => {
  // const [drawerOpen, setDrawerOpen] = useState<boolean>(true);
  // const [width, setWidth] = useState(getWidth());

  // const onResize = () => {
  //   setWidth(getWidth());
  // };

  // const toggleDrawer = () => {
  //   setDrawerOpen(!drawerOpen);
  // };

  // React.useEffect(() => {
  //   window.addEventListener('resize', onResize);

  //   if (width < 960) {
  //     setDrawerOpen(false);
  //   } else {
  //     setDrawerOpen(true);
  //   }

  // }, [width]);
  return (
    <>
      <Header />
      <main className={`${styles.content}`} data-testid="main-layout">
        <SideBar />
        <Suspense fallback={<Loader />}>
          <Container
            maxWidth="xl"
            className={`${styles.pageContent}`}
            // className={`${styles.pageContent}  ${
            //   !drawerOpen && styles.contentShift
            // }`}
          >
            {children ? children : ''}
          </Container>
        </Suspense>
      </main>
    </>
  );
};

export default Layout;
